import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { membershipCollection } from 'app/src/msw/membership/initialSeed/membership'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const patchMembership = http.patch<{ membershipId: string }, membershipApi.MembershipUpdateRequest, undefined>(
  apiBaseUrl + '/memberships/:membershipId',
  async ({ request, params }) => {
    const body = await request.json()

    const membership = membershipCollection.findFirst((q) => q.where({ membershipId: params.membershipId }))

    if (!membership) {
      const responseError: membershipApi.ErrorEntityNotFound = {
        status: 404,
        title: 'Membership non trovata',
        type: 'urn:notfound',
        rc: 404,
      }
      return HttpResponse.json(responseError, { status: 404 })
    }

    await membershipCollection.update(membership, {
      data(membership) {
        membership.userEmail = body.email ?? membership.userEmail
        membership.userIban = body.iban ?? membership.userIban
      },
    })

    await new Promise((resolve) => setTimeout(resolve, 3000))
    return HttpResponse.text(undefined, { status: 204 })
  },
)
